import * as React from 'react';
import { Button, Panel } from 'react-bootstrap';
import { inject } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
import { UiStore } from '../../stores/UiStore';

interface IErteilungAngebotProps {
  auftragId: string;
}

export default class ErteilungAngebot extends React.Component<IErteilungAngebotProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(UiStore) uiStore: UiStore;

  async setzeAuftragNichtErteilt() {
    const response = await this.apiStore.auftragNichtErteilt(this.props.auftragId);
    if (response.ok) {
      this.uiStore.navigateTo('/auftraege');
    }
  }

  render() {
    return (
      <Panel
        header="Auftrag zurückstellen "
        bsStyle="info"
        footer={(
          <div className="text-right">
            <Button onClick={() => this.setzeAuftragNichtErteilt()}>Zurückstellen</Button>
          </div>
        )}
      >
        Der Auftrag kam nicht zustande (z.B. weil das Angebot abgelehnt wurde). Er kann dann zurückgestellt werden und wird nicht mehr unter den aktiven Aufträgen gelistet.
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/ErteilungAngebot.tsx